import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

/** Indicador numérico (KPI) com rótulo, valor principal e linha de contexto. */
export default function StatTile({ label, value, helper, icon: Icon, loading = false, onClick }) {
    return (
        <Card
            onClick={onClick}
            sx={{
                px: 2.5,
                py: 2,
                cursor: onClick ? 'pointer' : 'default',
                transition: 'border-color 150ms',
                '&:hover': onClick ? { borderColor: '#D0D5DD' } : undefined,
                minWidth: 0,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }} noWrap>
                    {label}
                </Typography>
                {Icon && (
                    <Box sx={{ width: 30, height: 30, borderRadius: 1.5, border: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'text.secondary', flexShrink: 0 }}>
                        <Icon sx={{ fontSize: 17 }} />
                    </Box>
                )}
            </Box>
            <Typography sx={{ fontSize: '1.625rem', fontWeight: 600, letterSpacing: '-0.02em', mt: 0.75, lineHeight: 1.2 }}>
                {loading ? <Skeleton width="60%" /> : value}
            </Typography>
            {helper && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    {loading ? <Skeleton width="80%" /> : helper}
                </Typography>
            )}
        </Card>
    );
}
